import {
  GetAllPaymentsRequestBuilder,
  GetPaymentRequestBuilder,
  GetPaymentsCountRequestBuilder,
  ToPayRequestBuilder,
} from '../payment/payment';
import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class PaymentRepository {
  getPayments = async (actions: any) => {
    const makeInvoicesRequest = new GetAllPaymentsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();
    const makeCountRequest = new GetPaymentsCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeInvoicesRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getAllPayments = async (actions: any) => {
    const makeInvoicesRequest = new GetAllPaymentsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeInvoicesRequest);
    return response;
  };
  getPaymentWithId = async (actions: any) => {
    const makeInvoicesRequest = new GetPaymentRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeInvoicesRequest);

    return response;
  };
  requestToPay = async (actions: any) => {
    const {body} = actions.payload;
    console.log(body);
    const makeCreateInvoiceRequest = new ToPayRequestBuilder()
      .id(body.invoiceId)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeCreateInvoiceRequest);

    return response;
  };
}

export default new PaymentRepository();
